import axiosInstance from "./AxiosInstance";

export async function performLogout() {
  try {
    await axiosInstance.post("/logout");
  } catch (error) {
    console.error("Logout request failed:", error);
  }
}
